<template>
    <v-row class="my-1">
        <v-col cols="12">
            <v-alert
                type="error"
                class="shaded-light"
                border="left"
                colored-border
            >
                <div>
                    <slot name="title">
                        <strong>Urgent Emerging Carrier Issue:</strong> We recommend you temporarily refrain from sending bulk messages that promote wine sales. We're seeing unusual carrier blocking and will share updates as soon as we have more clarity.
                    </slot>
                </div>
                <div class="mt-2">
                    <a
                        href="#"
                        @click.prevent="show_details = !show_details"
                    >
                        {{ show_details ? 'Read less' : 'Read more' }}
                        <v-icon color="primary" small>{{ show_details ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </a>
                </div>

                <v-expand-transition>
                    <div
                        v-show="show_details"
                        class="mt-4"
                    >
                        <p><strong>What's happened:</strong></p>
                        <p>
                            We've just been made aware of unusual and unexpected carrier blocks affecting three wineries in rapid succession. These reports are separate but nearly identical, and we strongly disagree with the findings. We are actively pushing back, along with our sending carrier, on the relevant telecom entities.
                        </p>
                        <p>
                            Carrier blocks like these require all messages from the affected business to be temporarily blocked until the issue is resolved. To be clear: <strong>only the three wineries involved are currently experiencing message delivery interruptions</strong>, and we have already contacted them directly.
                        </p>
                        <p>
                            However, because we received multiple similar blocks in such a short time — something we have not seen before — we want to proactively share what we're seeing so you can take steps to reduce your risk while we try to get more answers.
                        </p>

                        <p><strong>What you should do right now:</strong></p>
                        <p>
                            Out of an abundance of caution, we recommend that you <strong>temporarily refrain from sending any bulk messages that promote wine sales</strong> until we have more clarity. If you're unsure whether a message is promoting wine sales, versus promoting something else or being informational, we recommend erring on the side of caution and not sending it for now.
                        </p>

                        <p><strong>What we're doing:</strong></p>
                        <p>
                            We are in urgent contact with our sending carrier and together are pushing back on these carrier-level blocks  while seeking clarification and resolution. While we're working on this without interruption, responses from telecom entities can sometimes be slow, and the holiday timing may impact their response time.
                        </p>
                        <p>
                            Please know that we are treating this with the highest priority and will continue to keep you informed as we learn more. We understand how frustrating this is, and our goal is to provide transparency and practical guidance while we work to resolve the situation as quickly as possible.
                        </p>
                    </div>
                </v-expand-transition>
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'TempDisableWineriesFromScheduling',

    data() {
        return {
            show_details: false,
        };
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>